import { MouseEvent, PropsWithChildren, RefObject } from 'react';
import classnames from 'classnames';
import { Popover, PopoverContent, PopoverTrigger } from '@ds';
import { MdOutlineChevronRight } from 'react-icons/md';
import { NestedDropdownProps } from './types';

type NestedDropdownPopoverProps = Pick<NestedDropdownProps, 'classNames' | 'trigger'> & {
  triggerRef: RefObject<HTMLDivElement | null>;
  contentRef: RefObject<HTMLDivElement | null>;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onClose: (event: MouseEvent<HTMLElement>) => void;
};

export const NestedDropdownPopover = ({
  triggerRef,
  contentRef,
  isOpen,
  onOpenChange,
  onClose,
  trigger,
  classNames: slots,
  children,
}: PropsWithChildren<NestedDropdownPopoverProps>) => {
  return (
    <Popover isOpen={isOpen} onOpenChange={onOpenChange} placement="right-start" offset={1} showArrow={false}>
      <PopoverTrigger className="aria-expanded:scale-[1] aria-expanded:opacity-100 w-full">
        <div ref={triggerRef} className="w-full p-2 rounded-lg *:text-m-r! flex items-center justify-between">
          <span className="min-w-0 truncate">{trigger}</span>
          <MdOutlineChevronRight className="shrink-0 text-base-20" size={16} />
        </div>
      </PopoverTrigger>
      <PopoverContent
        className={classnames(
          'max-w-none! flex outline-none bg-base-60 p-1 rounded-lg shadow-xl relative *:text-m-r!',
          slots?.content,
          slots?.submenuContent,
        )}
        onMouseEnter={() => onOpenChange(true)}
        onMouseLeave={onClose}
      >
        <div ref={contentRef} className="w-full flex-col gap-0.5">
          {children}
        </div>
      </PopoverContent>
    </Popover>
  );
};
